import React from 'react';

import { IExpirationMonthAndYear } from 'src/environments/Checkout/interfaces';

import {
  ContainerSelect,
  Expirationtitle,
  IconArrowDown,
  SelectDropdownExpiration,
  SelectExpirationContainer,
  SelectTitleDropdownContainer,
} from './style';

import iconArrowDownSVG from '../../../../../../../../../../assets/images/subscripiton-checkout-icons/arrow-down-icon.svg';

type Props = {
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
};

export default function SelectExpirationDate({ onChange }: Props): JSX.Element {
  const setExpirationDates = (): IExpirationMonthAndYear => {
    const now = new Date();
    const currYear = Number(now.getFullYear().toString().slice(2));

    const expirationMonths = [];
    const expirationYears = [];

    for (let i = 1; i <= 12; i += 1) {
      expirationMonths.push({ label: i < 10 ? `0${i}` : i, value: i });
    }

    for (let i = currYear; i < currYear + 20; i += 1) {
      expirationYears.push({ label: i < 10 ? `0${i}` : i, value: i });
    }

    return { expirationMonths, expirationYears };
  };

  return (
    <SelectTitleDropdownContainer>
      <Expirationtitle>Validade</Expirationtitle>
      <SelectExpirationContainer>
        <ContainerSelect>
          <SelectDropdownExpiration name="expMonth" required onChange={onChange}>
            <option value="" disabled selected>
              Mês
            </option>
            {setExpirationDates().expirationMonths.map((month, index) => (
              <option key={index} value={month.value}>
                {month.label}
              </option>
            ))}
          </SelectDropdownExpiration>
          <IconArrowDown src={iconArrowDownSVG} />
        </ContainerSelect>
        <ContainerSelect>
          <SelectDropdownExpiration name="expYear" required onChange={onChange}>
            <option value="" disabled selected>
              Ano
            </option>
            {setExpirationDates().expirationYears.map((year, index) => (
              <option key={index} value={year.value}>
                {year.label}
              </option>
            ))}
          </SelectDropdownExpiration>
          <IconArrowDown src={iconArrowDownSVG} />
        </ContainerSelect>
      </SelectExpirationContainer>
    </SelectTitleDropdownContainer>
  );
}
